<template>

<MotivoPermisos></MotivoPermisos>

</template>


<script>

import MotivoPermisos from '../../components/MotivoPermisos.vue';

export default {


 components:{

     MotivoPermisos

  }

}


</script>